import { Avatar, Box, Tooltip, Typography } from "@mui/material";
import React from "react";
import { stringAvatar } from "../../utils/helpers";
import HeaderText from "../../common/HeaderText";

const UserCard = ({ agentUser }) => {
  const showTooltip = agentUser?.agent?.email.length > 26;

  return (
    <Box display="flex" alignItems="center" gap="8px" padding="10px 0">
      {agentUser?.agent?.profile_picture_url ? (
        <Avatar
          sx={{ width: 40, height: 40 }}
          alt="Profile Picture"
          src={agentUser?.agent?.profile_picture_url}
        />
      ) : (
        <Avatar
          {...stringAvatar(agentUser?.agent?.name)}
          sx={{
            background: agentUser?.agent?.avatar_color,
            width: 40,
            height: 40,
            fontSize: "1.5rem",
          }}
        />
      )}

      <Box display="flex" flexDirection="column" gap="1px">
        <HeaderText
          variant="h3"
          fontSize="1.6rem"
          textContent={agentUser?.agent?.name}
          textAlign="inherit"
          color="#000"
        />
        {showTooltip ? (
          <Tooltip
            title={agentUser?.agent?.email}
            arrow
            placement="top-start"
            PopperProps={{
              sx: {
                marginLeft: "-14px !important",
                marginBottom: "-14px !important",
              },
            }}
          >
            <Typography
              variant="caption"
              fontWeight={500}
              sx={{
                width: "80%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {agentUser?.agent?.email}
            </Typography>
          </Tooltip>
        ) : (
          <Typography variant="caption" fontWeight={500}>
            {agentUser?.agent?.email}
          </Typography>
        )}

        {/* <HeaderText
          variant="h6"
          fontSize="1.2rem"
          fontWeight="400"
          textContent={agentUser?.agent?.email}
          textAlign="inherit"
        /> */}
      </Box>
    </Box>
  );
};

export default UserCard;
